import {config as API} from './api';
import {config as Auth} from './auth';
import {appSyncConfig} from "./appsync.ts";
import {ResourcesConfig} from "aws-amplify";

const endpoint = appSyncConfig.endpoint;

export const config = {
    Auth: Auth,
    API: {
        REST: API,
        GraphQL: {
            endpoint: endpoint,
            region: 'us-west-2',
            defaultAuthMode: 'userPool'
        }
    },
} as ResourcesConfig;